import { useSearchParams } from 'react-router-dom';
import { useFamilyChildren, type ChildProfile } from './useFamilyChildren';

// Single source of truth for "acting as a kid" mode.
// Reads ?as=<kid_id> from the URL and resolves it to a child profile,
// plus exposes helpers to thread the param through nav links.
export function useViewingAs() {
  const [searchParams] = useSearchParams();
  const asUserId = searchParams.get('as');
  const { data: kids } = useFamilyChildren();
  const asKid: ChildProfile | null =
    asUserId && kids ? kids.find((k) => k.id === asUserId) ?? null : null;

  // Append ?as= to a path, preserving the current acting-as context.
  function withAs(path: string): string {
    if (!asUserId) return path;
    const sep = path.includes('?') ? '&' : '?';
    return `${path}${sep}as=${asUserId}`;
  }

  return { asUserId, asKid, withAs };
}
